import { Component, OnInit } from '@angular/core';
import { ISpecificBrickSettingsComponent } from '../../../../dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { Store } from '@ngxs/store';
import { AgentDetailsSettingState } from '../../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/agent-details-brick-settings/agent-details-settings.state';
import { Observable } from 'rxjs';
import {
   ChangeNumOfCallHistoryEntriesToShow,
   ChangeShowAvatar,
   ChangeShowCaller,
   ChangeShowCallHistory,
   ChangeShowGroups,
   ChangeShowSkills,
} from '../../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/agent-details-brick-settings/agent-details-settings.action';
import { map } from 'rxjs/operators';

@Component({
   selector: 'samweb-agent-details-brick-settings',
   templateUrl: './agent-details-settings.component.html',
   styleUrls: ['./agent-details-settings.component.scss'],
})
export class AgentDetailsSettingsComponent implements OnInit, ISpecificBrickSettingsComponent {
   brickInstanceId: string;

   public numEntriesOfCallHistoryToShow$: Observable<number>;

   public showCaller$: Observable<boolean>;

   public showSkills$: Observable<boolean>;

   public showGroups$: Observable<boolean>;

   public showCallHistory$: Observable<boolean>;

   public showAvatar$: Observable<boolean>;

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.numEntriesOfCallHistoryToShow$ = this.store
         .select(AgentDetailsSettingState.getNumOfCallHistoryEntriesToShow)
         .pipe(map((fn) => fn(this.brickInstanceId)));
      this.showCaller$ = this.store.select(AgentDetailsSettingState.getShowCaller).pipe(map((fn) => fn(this.brickInstanceId)));
      this.showSkills$ = this.store.select(AgentDetailsSettingState.getShowSkills).pipe(map((fn) => fn(this.brickInstanceId)));
      this.showGroups$ = this.store.select(AgentDetailsSettingState.getShowGroups).pipe(map((fn) => fn(this.brickInstanceId)));
      this.showCallHistory$ = this.store.select(AgentDetailsSettingState.getShowCallHistory).pipe(map((fn) => fn(this.brickInstanceId)));
      this.showAvatar$ = this.store.select(AgentDetailsSettingState.getShowAvatar).pipe(map((fn) => fn(this.brickInstanceId)));
   }

   changeShowCaller(showCaller: boolean) {
      this.store.dispatch(new ChangeShowCaller(this.brickInstanceId, showCaller));
   }

   changeShowSkills(showSkills: boolean) {
      this.store.dispatch(new ChangeShowSkills(this.brickInstanceId, showSkills));
   }

   changeShowGroups(showGroups: boolean) {
      this.store.dispatch(new ChangeShowGroups(this.brickInstanceId, showGroups));
   }

   changeShowCallHistory(showCallHistory: boolean) {
      this.store.dispatch(new ChangeShowCallHistory(this.brickInstanceId, showCallHistory));
   }

   changeNumOfCallHistoryEntriesToShow(numOfCallHistoryEntriesToShow: number) {
      this.store.dispatch(new ChangeNumOfCallHistoryEntriesToShow(this.brickInstanceId, numOfCallHistoryEntriesToShow));
   }

   changeShowAvatar(showAvatar: boolean) {
      this.store.dispatch(new ChangeShowAvatar(this.brickInstanceId, showAvatar));
   }
}
